import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faAngleLeft,
} from "@fortawesome/free-solid-svg-icons";

import {
  Form,
  Button,
  Modal,
  FormCheck,
  Card,
} from "@themesberg/react-bootstrap";

import { useHistory } from "react-router-dom";
import axios from "axios";
// import ReCAPTCHA from "react-google-recaptcha";
import { Routes } from "../../routes";

import "./Signup.css";
import BASE_URL from "../../config";

const Signup = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    user_type: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  // const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaCode, setCaptchaCode] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const captchaCanvasRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("");

  const [loggedInUser, setLoggedInUser] = useState(null);

  const history = useHistory();

  /* =========================================
     CHECK LOGIN USER
  ========================================= */

    const generateCaptcha = () => {
      const characters =
        "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";

      let code = "";

      for (let i = 0; i < 6; i++) {
        code += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }

      setCaptchaCode(code);
      setCaptchaInput("");
    };

    useEffect(() => {
      generateCaptcha();
    }, []);


  useEffect(() => {
    if (!captchaCode || !captchaCanvasRef.current) {
      return;
    }

    const canvas = captchaCanvasRef.current;
    const ctx = canvas.getContext("2d");

    const width = 180;
    const height = 55;

    canvas.width = width;
    canvas.height = height;

    // Background
    ctx.fillStyle = "#f4f4f4";
    ctx.fillRect(0, 0, width, height);

    // Random background dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();

      ctx.arc(
        Math.random() * width,
        Math.random() * height,
        Math.random() * 1.5 + 0.5,
        0,
        Math.PI * 2
      );

      ctx.fillStyle = `rgba(80, 80, 80, ${Math.random() * 0.3})`;
      ctx.fill();
    }

    // Random lines
    for (let i = 0; i < 5; i++) {
      ctx.beginPath();

      ctx.moveTo(
        Math.random() * width,
        Math.random() * height
      );

      ctx.lineTo(
        Math.random() * width,
        Math.random() * height
      );

      ctx.strokeStyle = `rgba(60, 60, 60, ${Math.random() * 0.4 + 0.2})`;
      ctx.lineWidth = 1;

      ctx.stroke();
    }

    // Draw CAPTCHA characters
    const colors = [
      "#333333",
      "#444444",
      "#222222",
      "#555555",
      "#111111",
    ];

    for (let i = 0; i < captchaCode.length; i++) {
      const char = captchaCode[i];

      ctx.save();

      const x = 18 + i * 27;
      const y = 38;

      // Random rotation
      const rotation =
        (Math.random() - 0.5) * 0.5;

      ctx.translate(x, y);
      ctx.rotate(rotation);

      ctx.font = "bold 27px Arial";
      ctx.fillStyle =
        colors[Math.floor(Math.random() * colors.length)];

      ctx.fillText(char, 0, 0);

      ctx.restore();
    }

    // Border
    ctx.strokeStyle = "#cccccc";
    ctx.lineWidth = 1;
    ctx.strokeRect(0, 0, width, height);

  }, [captchaCode]);

  /* =========================================
     HANDLE INPUT
  ========================================= */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* =========================================
     CAPTCHA
  ========================================= */

  // const handleCaptchaVerify = (token) => {
  //   setCaptchaToken(token);
  //   setError("");
  // };

  /* =========================================
     SUBMIT
  ========================================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    /* Password validation */

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    /* CAPTCHA validation */

    if (!captchaInput.trim()) {
      setError("Please enter the CAPTCHA.");
      return;
    }

    if (
      captchaInput.trim().toLowerCase() !==
      captchaCode.toLowerCase()
    ) {
      setError("Invalid CAPTCHA. Please try again.");
      generateCaptcha();
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/api.php`, {
        type: "SignUp",
        name: formData.name,
        user_type: formData.user_type,
        email: formData.email,
        password: formData.password,
      });

      if (
        response.status === 201 &&
        response.data.status === "success"
      ) {
        setSuccess(response.data.message);

        setFormData({
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          user_type: "",
        });

        generateCaptcha();

        setModalMessage(response.data.message);
        setModalType("success");
        setShowModal(true);
      } else {
        const message =
          response.data.error ||
          response.data.message ||
          "Error creating user.";

        setError(message);

        setModalMessage(message);
        setModalType("error");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Signup error:", error);

      let message = "A network or server error occurred.";

      if (error.response) {
        message =
          error.response.data?.error ||
          error.response.data?.message ||
          "Error creating user.";
      }

      setError(message);

      setModalMessage(message);
      setModalType("error");
      setShowModal(true);
    }
  };

  /* =========================================
     MODAL CLOSE
  ========================================= */

  // const handleModalClose = () => {
  //   setShowModal(false);

  //   if (modalType === "success") {
  //     history.push(Routes.Userlists.path);
  //   }
  // };

  const handleModalClose = () => {
    setShowModal(false);

    window.location.reload();
    // Do NOT redirect after signup.
    // User must verify email first.
  };

  /* =========================================
     BACK TO LOGIN
  ========================================= */

  const handleBackToLogin = () => {
    history.push(Routes.Signin.path);
  };

  /* =========================================
     RENDER
  ========================================= */

  return (
    <main className="signup-page">

      {/* =====================================
          BACK TO LOGIN
      ====================================== */}

      {!loggedInUser && (
        <div className="signup-back-wrapper">
          <button
            type="button"
            className="btn btn-link signup-back-btn"
            onClick={handleBackToLogin}
          >
            <FontAwesomeIcon
              icon={faAngleLeft}
              className="signup-back-icon"
            />

            Back to Login
          </button>
        </div>
      )}

      {/* =====================================
          MAIN CONTENT
      ====================================== */}

      <div className="signup-main-container">

        {/* ===================================
            LEFT SERVICES
        ==================================== */}

        <div className="signup-service-column">
          <div className="signup-service-container">

            <h4 className="signup-service-title">
              Services
            </h4>

            <ul className="signup-service-list">
              <li>Software Downloads</li>
              <li>SEO Services</li>
              <li>Ticket Brokers</li>
              <li>Tax Resolution Companies</li>
              <li>Business Opportunities</li>
              <li>Annual Contracts</li>
              <li>Magazine Sales</li>
              <li>Marketing-Advertising</li>
            </ul>

          </div>
        </div>

        {/* ===================================
            CENTER SIGNUP FORM
        ==================================== */}

        <div className="signup-form-column">

          <div className="signup-form-glow">

            {/* Header */}

            <div className="signup-title-section">

              <h3 className="signup-title">
                Create Your Account
              </h3>

              <p className="signup-subtitle">
                It only takes a minute to sign up!
              </p>

            </div>

            {/* Error */}

            {error && (
              <div className="signup-error">
                {error}
              </div>
            )}

            {/* Success */}

            {success && (
              <div className="signup-success">
                {success}
              </div>
            )}

            {/* =================================
                FORM
            ================================== */}

            <Form
              onSubmit={handleSubmit}
              className="signup-form"
              autoComplete="off"
            >

              {/* Name */}

              <Form.Group
                id="name"
                className="mb-4"
              >
                <Form.Label>
                  Your Name
                </Form.Label>

                <Form.Control
                  autoFocus
                  required
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* Email */}

              <Form.Group
                id="email"
                className="mb-4"
              >
                <Form.Label>
                  Your Email
                </Form.Label>

                <Form.Control
                  required
                  type="email"
                  placeholder="example@company.com"
                  name="email"
                  autoComplete="new-email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* User Type */}

              {loggedInUser && (
                <Form.Group
                  id="user_type"
                  className="mb-4"
                >
                  <Form.Label>
                    User Type
                  </Form.Label>

                  <Form.Select
                    name="user_type"
                    value={formData.user_type}
                    onChange={handleChange}
                  >
                    <option value="">
                      Select User Type
                    </option>

                    <option value="0">
                      Management
                    </option>

                    <option value="1">
                      Admin
                    </option>

                    <option value="2">
                      Applicant
                    </option>
                  </Form.Select>
                </Form.Group>
              )}

              {/* Password */}

              <Form.Group
                id="password"
                className="mb-4"
              >
                <Form.Label>
                  Your Password
                </Form.Label>

                <Form.Control
                  required
                  type="password"
                  placeholder="Password"
                  name="password"
                  autoComplete="new-password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* Confirm Password */}

              <Form.Group
                id="confirmPassword"
                className="mb-4"
              >
                <Form.Label>
                  Confirm Password
                </Form.Label>

                <Form.Control
                  required
                  type="password"
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* =================================
                  CAPTCHA
              ================================== */}

              <div className="signup-captcha">

              <div className="captcha-box-wrapper">

                <canvas
                  ref={captchaCanvasRef}
                  className="captcha-image"
                  width="180"
                  height="55"
                />

                <Button
                  type="button"
                  variant="outline-secondary"
                  className="captcha-refresh-btn"
                  onClick={generateCaptcha}
                  title="Refresh CAPTCHA"
                >
                  ↻
                </Button>

              </div>

              <Form.Control
                type="text"
                placeholder="Enter CAPTCHA"
                value={captchaInput}
                onChange={(e) => {
                  setCaptchaInput(e.target.value);
                  setError("");
                }}
                autoComplete="off"
                maxLength={6}
                required
              />

            </div>

              {/* =================================
                  TERMS
              ================================== */}

              <div className="signup-terms">

                <FormCheck.Input
                  required
                  id="terms"
                  className="me-2"
                />

                <FormCheck.Label htmlFor="terms">
                  I agree to the{" "}
                  <Card.Link href="#">
                    terms and conditions
                  </Card.Link>
                </FormCheck.Label>

              </div>

              {/* =================================
                  SUBMIT
              ================================== */}

              <Button
                type="submit"
                className="signup-submit-btn"
              >
                Sign Up
              </Button>

            </Form>

          </div>

        </div>

        {/* ===================================
            RIGHT SERVICES
        ==================================== */}

        <div className="signup-service-column">

          <div className="signup-service-container">

            <h4 className="signup-service-title">
              Services
            </h4>

            <ul className="signup-service-list">
              <li>Moving Company</li>
              <li>Pawn Shops & Pawnbrokers</li>
              <li>Pet Shops & Supply Stores</li>
              <li>Self-Storage Business</li>
              <li>Bitcoin</li>
              <li>Infographics</li>
              <li>Peer-To-Peer Loans</li>
              <li>Multi-Level Marketing</li>
            </ul>

          </div>

        </div>

      </div>

      {/* =====================================
          SUCCESS / ERROR MODAL
      ====================================== */}

      <Modal
        show={showModal}
        onHide={handleModalClose}
        centered
      >
        <Modal.Header closeButton>

          <Modal.Title>
            {modalType === "success"
              ? "Registration Successful"
              : "Registration Failed"}
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>

          <div className="d-flex align-items-center">

            <FontAwesomeIcon
              icon={
                modalType === "success"
                  ? faCheckCircle
                  : faTimesCircle
              }
              className={`me-2 ${
                modalType === "success"
                  ? "text-success"
                  : "text-danger"
              }`}
              size="lg"
            />

            <span
              className={`fw-semibold ${
                modalType === "success"
                  ? "text-success"
                  : "text-danger"
              }`}
            >
              {modalMessage}
            </span>

          </div>

        </Modal.Body>

        <Modal.Footer>

          {/* <Button
            variant={
              modalType === "success"
                ? "success"
                : "danger"
            }
            onClick={handleModalClose}
          >
            {modalType === "success"
              ? "Go to Dashboard"
              : "Close"}
          </Button> */}

        </Modal.Footer>

      </Modal>

    </main>
  );
};

export default Signup;